// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const ChangeCurrency = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeLinecap="square" d="M10.5 9.5 12 11l-1.5 1.5" />
    <path stroke="currentColor" d="M6 7h6.5a2 2 0 0 1 2 2v3.5a2 2 0 0 1-2 2h-6" />
    <path stroke="currentColor" d="M12 11H5.5a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h6" />
    <path stroke="currentColor" strokeLinecap="square" d="M7.5 8.5 6 7l1.5-1.5" />
  </svg>
);
const ForwardRef = forwardRef(ChangeCurrency);
export default ForwardRef;
